import { Account } from "callable-data-objects";
import React, { Fragment } from "react";
import { Container, Divider, Header, Message } from "semantic-ui-react";
import AccountSetting from "./AccountSetting";

type AccountLocaleProps = {
  account: Account;
};

function AccountTeams({ account }: AccountLocaleProps) {
  const domain = account.settings.find((s) => s.key === "teamsDomain");
  const domainType = account.settings.find((s) => s.key === "teamsDomainType")
    ?.value;
  return (
    <Container>
      <Header as='h3'>Update MS Teams</Header>
      <Divider />
      <AccountSetting
        account={account}
        name='teamsDomain'
        type='string'
        label='MS Teams Domain'
      />

      {domain && (
        <AccountSetting
          account={account}
          name='teamsDomainType'
          type='teamsDomainType'
          label='Domain Type'
        />
      )}
      {domain && domainType && domainType === "legacy" && (
        <Fragment>
          <Message info>
            You are required to build the following domains on MS Teams <br />
            <ul>
              <li>
                <b>{domain?.value}.customers.viva-uk.net</b>
              </li>
              <li>
                <b>{domain?.value}.customers.viva-eu.net</b>
              </li>
            </ul>
          </Message>
          <AccountSetting
            account={account}
            name='teamsDomainUKTXT'
            type='string'
            label='VIVA UK TXT Record Value ("MS=msXXXXXXXX")'
          />

          <AccountSetting
            account={account}
            name='teamsDomainEUTXT'
            type='string'
            label='VIVA EU TXT Record Value ("MS=msXXXXXXXX")'
          />
        </Fragment>
      )}
      {domain && domainType && domainType === "callable" && (
        <Fragment>
          <Message info>
            You are required to build the following domains on MS Teams <br />
            <ul>
              <li>
                <b>{domain?.value}.teams.callable.io</b>
              </li>
            </ul>
            <br />
            To validate the domain, MS requests you add a TXT record
            MS=msXXXXXXXX. Please add this below
          </Message>
          <AccountSetting
            account={account}
            name='teamsDomainTXT'
            type='string'
            label='TXT Record Value'
            placeholder='MS=msXXXXXXXX'
          />
        </Fragment>
      )}
    </Container>
  );
}

export default AccountTeams;
